var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6892 17.595C29.5017 23.5325 25.0248 29.1232 18.7429 30.3725C15.6792 30.9826 12.501 30.6106 9.66095 29.3094C6.82091 28.0082 4.46378 25.8441 2.92519 23.1254C1.38661 20.4066 0.745 17.2717 1.09173 14.1671C1.43846 11.0624 2.75585 8.14632 4.85632 5.83396C9.16457 1.08871 16.4392 -0.217543 22.3767 2.15746",
    stroke: "#0EB41F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.502 15.2198L16.4395 21.1573L30.6895 5.71985",
    stroke: "#0EB41F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointers);
export default __webpack_public_path__ + "static/media/pointers.2a83aa0d00564da3092f507c4c4bc7d9.svg";
export { ForwardRef as ReactComponent };